import { MDXEditor } from '@mdxeditor/editor';
import { Stack, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';
import Markdown from 'react-markdown';

import { MARKDOWN_REMARK_PLUGINS } from '@/constants/markdown.constants';
import { ANNOUNCEMENT_MDX_EDITOR_CONFIG } from '@/pages/Announcements/AnnouncementDialog/AnnouncementDialog.constants';

import type { EPInternalNotesProps } from './EscalationProfile.types';

const EPInternalNotes = ({
  isEditing,
  control,
  mdxRef,
  themeMode,
  internalNotes
}: EPInternalNotesProps) => (
  <Stack spacing={1}>
    <Typography sx={{ fontWeight: 'bold' }} variant="h5">
      Internal Notes
    </Typography>
    {isEditing ? (
      <Stack className={themeMode ?? undefined}>
        <Controller
          name="internal_notes"
          control={control}
          render={({ field }) => (
            <MDXEditor
              ref={mdxRef}
              markdown={field.value ?? ''}
              onChange={(val) => field.onChange(val.replaceAll('&#x20;', ''))}
              plugins={ANNOUNCEMENT_MDX_EDITOR_CONFIG}
            />
          )}
        />
      </Stack>
    ) : (
      <Markdown remarkPlugins={MARKDOWN_REMARK_PLUGINS}>
        {internalNotes || 'No internal notes provided.'}
      </Markdown>
    )}
  </Stack>
);

export default EPInternalNotes;
